'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hours;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/hours.js
// module id = 338
// module chunks = 1